import React, { useEffect, useState } from "react";
import MainContainer from "../../container/MainContainer";
import { Link, useParams, useHistory } from "react-router-dom";
import Arrow from "../../images/Arrow-Right.svg";
import Generalinfo from "./Generalinfo";
import Expiration from "./Expiration";
import ReviewPublish from "./ReviewPublish";
import { useLazyQuery } from "@apollo/react-hooks";
import { GET_DEAL_BY_ID } from "../../query/getDealById";
import { hasuraClient } from "../../apolloClient";
import { ADD_DEAL } from "../../mutation/addDeal";
import { VIEW_PROFILE } from "../../query/ViewProfile";
import { useMutation,useQuery} from "@apollo/client";
import { UPADTE_DEAL } from "../../mutation/updateDeal";
import moment from "moment";
import ReferralSuccessModal from "../Common/SuccessModal";

const CreateDeal = () => {
  const params = useParams();
  const history = useHistory();

  const [generalInfo, setGeneralInfo] = useState(null);
  const [expirationData, setExpirationData] = useState(null);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [isPostSuccess, setIsPostSuccess] = useState(false);
  const [uniqueError, setUniqueError] = useState(null);

  const { data } = useQuery(VIEW_PROFILE, {
    client: hasuraClient,
  });

  const [addDeal] = useMutation(ADD_DEAL, {
    client: hasuraClient,
  });

  const [updateDeal] = useMutation(UPADTE_DEAL, {
    client: hasuraClient,
  });

  const [
    getDealById,
    { data: dealsData, loading: dealsLoading, error: dealsError },
  ] = useLazyQuery(GET_DEAL_BY_ID, {
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });

  useEffect(() => {
    if (params.id) {
      getDealById({
        variables: {
          id: params.id,
        },
      });
    }
  }, []);

  useEffect(() => {
    if (!dealsLoading && dealsData && !dealsError) {
      let obj = {
        dealName: dealsData.deals_by_pk.name,
        desc: dealsData.deals_by_pk.description,
        condition: dealsData.deals_by_pk.condition,
        dealType: dealsData.deals_by_pk.type,
        uploadedImg: dealsData.deals_by_pk.image_url,
        imagePath: dealsData.deals_by_pk.image_path,
      };

      setGeneralInfo(obj);

      let obj2 = {
        date: new Date(dealsData.deals_by_pk.expire_date_time),
        time: new Date(dealsData.deals_by_pk.expire_date_time),
      };

      setExpirationData(obj2);
    }
  }, [dealsLoading, dealsData, dealsError]);

  const handlePublish = () => {
    if (
      generalInfo &&
      expirationData &&
      generalInfo?.dealName &&
      generalInfo?.dealType &&
      generalInfo?.desc &&
      expirationData?.date &&
      expirationData?.time &&
      generalInfo?.imagePath &&
      generalInfo?.uploadedImg
    ) {
      setLoading(true);

      if (params.id) {
        updateDeal({
          variables: {
            id: params.id,
            name: generalInfo.dealName.trimStart().trimEnd(),
            type: generalInfo.dealType,
            condition: generalInfo.condition,
            description: generalInfo.desc,
            expire_date_time:
              moment(expirationData.date).format("YYYY-MM-DD").toString() +
              " " +
              moment(expirationData.time).format("HH:MM").toString(),
            image_path: generalInfo?.imagePath,
            image_url: generalInfo.uploadedImg,
          },
        })
          .then(() => {
            setLoading(false);
            setIsPostSuccess(true);
          })
          .catch(() => {
            setLoading(false);
          });
      } else {
        addDeal({
          variables: {
            name: generalInfo.dealName.trimStart().trimEnd(),
            type: generalInfo.dealType,
            condition: generalInfo.condition,
            description: generalInfo.desc,
            expire_date_time:
              moment(expirationData.date).format("YYYY-MM-DD").toString() +
              " " +
              moment(expirationData.time).format("HH:MM").toString(),
            business_profile_id: data?.users[0]?.business_profile?.id,
            club_profile_id: data?.users[0]?.club_profile?.id,
            image_path: generalInfo.imagePath,
            image_url: generalInfo.uploadedImg,
          },
        })
          .then(() => {
            setLoading(false);
            setIsPostSuccess(true);
          })
          .catch((e) => {
            let er = e.graphQLErrors;

            if (er && er.length) {
              if (er[0].message.includes("Uniqueness")) {
                setUniqueError("Deal name already used.");
              }
            }

            setLoading(false);
          });
      }
    }
  };

  return (
    <MainContainer active="deals">
      <>
        <ReferralSuccessModal
          show={isPostSuccess}
          setIsPostSuccess={setIsPostSuccess}
          onHide={() => {
            setIsPostSuccess(false);
            history.push("/deals");
          }}
          message={
            params.id
              ? `
        Your deal has
been updated
        `
              : `
        Great! You have published 
${generalInfo?.dealName ?? ""}
        `
          }
        />
        <section className="post-block event-block">
          <div className="main-title">
            <div className="back-button">
              <Link to="/deals">
                <img src={Arrow} alt="arrow right" />
              </Link>
              <h1> {params.id ? "Edit" : "Create"} Deal</h1>
            </div>
            {params.id && step !== 3 ? (
              <div className="edit-btn">
                <button
                  onClick={() => {
                    handlePublish();
                  }}
                >
                  Save and exit
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="event-step-cover">
            <ul className="eventstep-menu">
              <li className={step === 1 ? "active" : ""}>
                <p>1. General info</p>
              </li>
              <li className={step === 2 ? "active" : ""}>
                <p>2. Expiration</p>
              </li>
              <li className={step === 3 ? "active" : ""}>
                <p>3. Review & Publish</p>
              </li>
            </ul>
            {step === 1 ? (
              <Generalinfo
                setGeneralInfo={setGeneralInfo}
                setStep={setStep}
                generalInfo={generalInfo}
              />
            ) : step === 2 ? (
              <Expiration
                setStep={setStep}
                setExpirationData={setExpirationData}
                expirationData={expirationData}
              />
            ) : step === 3 ? (
              <ReviewPublish
                setStep={setStep}
                generalInfo={generalInfo}
                expirationData={expirationData}
                editId={params.id}
                handlePublish={handlePublish}
                loading={loading}
                uniqueError={uniqueError}
                setUniqueError={setUniqueError}
              />
            ) : (
              ""
            )}
          </div>
        </section>
      </>
    </MainContainer>
  );
};

export default CreateDeal;
